import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import axios from 'axios';

import { notificationBanner } from '@/vue3/composables/useBannerNotification';

Vue.use(VueRouter);

const routes = [
    {
        path: '/admin/accounts',
        name: 'admin-accounts',
        component: () =>
            import(/* webpackChunkName: "clere" */ '@/vue3/views/Accounts.vue'),
    },
    {
        path: '/admin/roles',
        name: 'admin-roles',
        component: () =>
            import(/* webpackChunkName: "clere" */ '@/vue3/views/Roles.vue'),
    },
    {
        path: '/admin/course-schemas',
        name: 'admin-course-schemas',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/CourseSchemas.vue'
            ),
    },
    {
        path: '/admin/ball-data-harvester',
        name: 'admin-ball-data-harvester',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/BallDataHarvester.vue'
            ),
    },
    {
        path: '/admin/pace-of-play',
        name: 'admin-pace-of-play',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PaceOfPlay.vue'
            ),
    },
    {
        path: '/admin/dashboard',
        name: 'admin-dashboard',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/AdminDashboard.vue'
            ),
    },
    {
        path: '/pinzone',
        name: 'pinzone',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PinzoneDashboard.vue'
            ),
    },
    {
    path: '/pinzone/editor',
    name: 'pinzone-editor',
    component: () =>
        import(/* webpackChunkName: "clere" */ '@/vue3/views/PinzoneEditor.vue'),
},
    {
        path: '/pinzone/editor/:id',
        name: 'pinzone-editor-id',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PinzoneEditor.vue'
            ),
        props: (route) => ({ rowId: Number(route.params.id) }),
    },
    {
        path: '/pinzone/pin-analysis',
        name: 'pin-analysis',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/components/pinzone/pinzoneAnalysis.vue'
            ),
    },
    {
        path: '/pinzone/categories',
        name: 'pinzone-categories',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PinzoneCategories.vue'
            ),
    },
    {
        path: '/pinzone/editor/:id',
        name: 'pinzone-editor-id',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PinzoneEditor.vue'
            ),
    },
    {
        path: '/pinzone/table',
        name: 'pinzone-table',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PinzoneTable.vue'
            ),
    },

    {
        path: '/task-manager',
        name: 'task-manager',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/TaskManagerTaskList.vue'
            ),
    },
    {
        path: '/task-manager-archived',
        name: 'task-manager-archived',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/TaskManagerArchivedTaskList.vue'
            ),
    },

    // {
    //     path: '/ground2control',
    //     name: 'ground2control',
    //     component: () =>
    //         import(
    //             /* webpackChunkName: "clere" */ '@/vue3/views/Ground2Control.vue'
    //         ),
    // },
    {
        path: '/gdd',
        name: 'gdd',
        component: () =>
            import(/* webpackChunkName: "clere" */ '@/vue3/views/Gdd.vue'),
    },
    {
        path: '/gdd-products',
        name: 'gdd-products',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GddProduct.vue'
            ),
    },
    {
        path: '/settings',
        name: 'settings',
        component: () =>
            import(/* webpackChunkName: "clere" */ '@/vue3/views/Settings.vue'),
    },
    {
        path: '/my-account',
        name: 'my-account',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/MyAccount.vue'
            ),
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PrivacyPolicy.vue'
            ),
    },
    {
        path: '/switch-account',
        name: 'switch-account',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/SwitchAccount.vue'
            ),
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/Dashboard.vue'
            ),
    },
    {
        path: '/geo-record/geo-record-projects',
        name: 'geo-record-project',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GeoRecordProjects.vue'
            ),
    },
    {
        path: '/geo-record/geo-record-history',
        name: 'geo-record-project',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GeoRecordHistory.vue'
            ),
    },
    {
        path: '/admin/geo-record-categories',
        name: 'geo-record-category',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GeoRecordCategories.vue'
            ),
    },
    {
        path: '/admin/geo-record-category-custom-layer',
        name: 'geo-record-category-custom-layer',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GeoRecordCategoryCustomLayers.vue'
            ),
    },
    {
        path: '/admin/geo-record-category-icons',
        name: 'geo-record-category-icon',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GeoRecordCategoryIcons.vue'
            ),
    },
    {
        path: '/admin/event-logs',
        name: 'event-log-grid',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/EventLogs.vue'
            ),
    },
    {
        path: '/admin/organizations',
        name: 'organizations',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/Organizations.vue'
            ),
    },
    {
        path: '/feedback',
        name: 'feedback',
        component: () =>
            import(/* webpackChunkName: "clere" */ '@/vue3/views/Feedback.vue'),
    },
    {
        path: '/tournament/putt',
        name: 'tournament-putt',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/TournamentPutt.vue'
            ),
    },
    {
        path: '/tournament/putt-grid',
        name: 'tournament-putt-grid',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/TournamentPuttGrid.vue'
            ),
    },
    {
        path: '/course-manager',
        name: 'course-manager',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/CourseManager.vue'
            ),
    },
    {
        path: '/project-manager',
        name: 'project-manager',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/ProjectManager.vue'
            ),
    },
    {
        path: '/projects',
        name: 'projects',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/ProjectsSG.vue'
            ),
    },
    {
        path: '/airtable',
        name: 'airtable',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/Airtable.vue'
            ),
    },
    {
        path: '/buggyTracker',
        name: 'buggyTracker',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/BuggyTracker.vue'
            ),
    },
    {
        path: '/admin/geo-record-models',
        name: 'geo-record-models',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/GeoRecordModels.vue'
            ),
    },
    {
        path: '/course-overview',
        name: 'CourseOverview',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/CourseOverview.vue'
            ),
    },
    {
        path: '/admin/notification-manager',
        name: 'notificationManager',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/NotificationManager.vue'
            ),
    },
    {
        path: '/admin/notification-type-editor',
        name: 'notificationTypeEditor',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/NotificationTypeManager.vue'
            ),
    },
    {
        path: '/admin/project/partner-module-manager',
        name: 'projectSGPartnerModuleManager',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/ProjectsSGPartnerModuleManager.vue'
            ),
    },
    {
        path: '/admin/product/clere-product',
        name: 'clereProductManager',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/ClereProducts.vue'
            ),
    },
    {
        path: '/admin/project/default-module-manager',
        name: 'projectSGDefaultModuleTemplateManager',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/ProjectSGDefaultModuleTemplateManager.vue'
            ),
    },
    {
        path: '/admin/project/category-template-manager',
        name: 'projectSGCategoryTemplates',
        component: () =>
            import(
                /* webpackChunkName: "course-manager" */ '@/vue3/views/ProjectSGCategoryTemplates.vue'
            ),
    },
    {
        path: '/tournament/ball-position',
        name: 'tournament-ball-position',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/ImgBallPositions.vue'
            ),
    },
    {
        path: '/putt',
        name: 'putt',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PuttPredictor.vue'
            ),
    },
    {
        path: '/login',
        name: 'login-form',
        component: () =>
            import(/* webpackChunkName: "clere" */ '@/vue3/views/LogIn.vue'),
    },
    {
        path: '/forgotten-password',
        name: 'forgotten-password-form',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/ForgottenPassword.vue'
            ),
    },
    {
        path: '/u/reset-password',
        name: 'reset-password',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/ResetPassword.vue'
            ),
    },
    {
        path: '/u/set-password',
        name: 'set-password',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/ResetPassword.vue'
            ),
    },
    {
        path: '/u/sign-up',
        name: 'sign-up',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/SignUp.vue'
            ),
    },
    {
        path: '/u/verify-email',
        name: 'verify-email',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/VerifyEmail.vue'
            ),
    },
    {
        path: '/geo-record/geo-record-archive-events',
        name: 'geo-record-archive-events',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/GeoRecordArchiveEvents.vue'
            ),
    },
    {
        path: '/admin/whs-manager',
        name: 'whs-manager',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/WHSManager.vue'
            ),
    },
    {
        path: '/admin/course-companion-manager',
        name: 'course-companion-manager',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/WHSCourseCompanionManager.vue'
            ),
    },
    {
        path: '/admin/whs-whitelabel-manager',
        name: 'whs-whitelabel-manager',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/WHSWhitelabelManager.vue'
            ),
    },
    {
        path: '/admin/pinzone-external-embed',
        name: 'pinzone-external-embed',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PinzoneExternalEmbedManager.vue'
            ),
    },
    {
        path: '/clere-tutorial-videos',
        name: 'clere-tutorial-videos',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/TutorialVideos.vue'
            ),
    },
    {
        path: '/flythrough',
        name: 'flythrough',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/Flythrough.vue'
            ),
    },
    {
        path: '/location-tracking',
        name: 'location-tracking',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/LocationTracking.vue'
            ),
    },
    {
        path: '/admin/app-push-notification',
        name: 'app-push-notification',
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/AppPushNotification.vue'
            ),
    },
    {
        path: '/public/course/share-link/:courseName/:linkName',
        name: 'public-course-share-link',
        meta: { isPublic: true },
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PublicInfo.vue'
            ),
    },
    {
        path: '/public/course/:courseName/:linkName',
        name: 'public-course-info-by-name',
        meta: { isPublic: true },
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PublicInfo.vue'
            ),
    },
    {
        path: '/public/course/:uid',
        name: 'public-course-info',
        meta: { isPublic: true },
        component: () =>
            import(
                /* webpackChunkName: "clere" */ '@/vue3/views/PublicInfo.vue'
            ),
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/login',
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkExactActiveClass: 'is-active',
    routes,
});

const getNotificationLatestCountAsUser = async () => {
    const token = JSON.parse(store.state.authToken || "{}").token
    if(token){
        const {status, data:{count, banner}} = await axios.get(`${store.state.apiUrl}/notification/u/latest`, { headers: {"Authorization" : `Bearer ${token}`}})
        if(status == 200){
            store.commit('setNotificationCount', `${count}`)
            if(banner && banner.isActive){
                notificationBanner.show(banner);
            } else {
                notificationBanner.hide();
            }
        }
    }
};

router.beforeEach((to: any, from: any, next: any) => {
    if (to.meta.isPublic) {
        store.state.cancelToken = axios.CancelToken.source();
        next();
        return;
    }

    store.state.cancelToken.cancel('Operation cancelled by the user.');

    if (store.state.alwaysAllowedRoutes.indexOf(to.path) !== -1) {
        next();
        return;
    }

    if (
        !store.state.authToken ||
        !store.state.account ||
        new Date(JSON.parse(store.state.account).accessUntil) < new Date()
    ) {
        if (store.state.allowedRoutes.indexOf(to.path) !== -1) {
            store.state.cancelToken = axios.CancelToken.source();
            next();
            return;
        } else {
            next('/login');
            return;
        }
    } else {
        axios
            .post(`${store.state.apiUrl}/auth/check`, store.state.authToken, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((response: any) => {
                getNotificationLatestCountAsUser();
                if (store.state.allowedRoutes.indexOf(to.path) !== -1) {
                    next('/course-manager');
                    return;
                } else {
                    store.state.cancelToken = axios.CancelToken.source();
                    next();
                    return;
                }
            })
            .catch((error: any) => {
                store.state.authToken = null;
                next('/login');
                return;
            });
    }
});

export const useRouter = () => {
    return router;
};

export default router;
